// import React from "react";
import { Route, Routes } from "react-router-dom";
import HealthTwoHome from "../healthTwoPages/healthTwoHome/HealthTwoHome";
import Navbar from "../../../../../src/default-components/Navbar";
import "../healthTwoCss/HealthTwoStyle.scss";
import GlobalRoute from "../../../../global route/GlobalRoute";
import PGBusinessThreeAboutUs from "../../../business/businessThree/businessThreePages/PGBusinessThreeAboutUs";

const HealthOneRoute = () => {
  return (
    <div className="health-two-route-parent">
      <Navbar />
      <Routes>
        <Route path="/" element={<HealthTwoHome />}></Route>
        <Route path="/aboutus" element={<PGBusinessThreeAboutUs />}></Route>
      </Routes>
      <GlobalRoute></GlobalRoute>
    </div>
  );
};

export default HealthOneRoute;
